<div class="modal-container">
  <div class="modal-header">
    <h5 class="header-title">Delete/Detach</h5>
  </div>

  <div class="modal-body">
    <!-- <h6 class="body-title">Are you sure you want to delete this {{ entityType }}?</h6> -->
    <p>Are you sure you want to delete this element?</p>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" (click)="onDismiss('cancel')">Cancel</button>
    <button class="btn-main" (click)="confirmDelete()">Confirm</button>
  </div>
</div>